var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.haveVettingBookingRequest
    ? _c("div", [
        _c("div", { staticClass: "dashboard-page-title" }, [
          _c(
            "div",
            { staticClass: "container-fluid" },
            [
              _vm.booking && _vm.booking.campaign
                ? _c("booking-campaign-banner", {
                    attrs: { campaign: _vm.booking.campaign },
                  })
                : _vm._e(),
              _vm._v(" "),
              _c("div", { staticClass: "row" }, [
                _c("div", { staticClass: "col-md-6" }, [
                  _c("h1", [
                    _vm._v(
                      _vm._s(_vm.isDraftVettingRequest ? "Draft" : "Pending") +
                        " " +
                        _vm._s(_vm.$t("Request")) +
                        " #" +
                        _vm._s(_vm._f("padded")(_vm.booking.id, "0", 5))
                    ),
                  ]),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "col-md-6" },
                  [_c("booking-status", { attrs: { booking: _vm.booking } })],
                  1
                ),
              ]),
            ],
            1
          ),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "container-fluid" },
          [
            _vm.$userIsAdmin
              ? _c("booking-search-details-list-admin", {
                  attrs: { booking: _vm.booking },
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.$userIsClient
              ? _c("booking-progress", { attrs: { booking: _vm.booking } })
              : _vm._e(),
            _vm._v(" "),
            _c("booking-details", {
              attrs: {
                booking: _vm.booking,
                "property-mutator": _vm.setVettingRequestProperty,
              },
            }),
            _vm._v(" "),
            _vm.$userIsAdmin ||
            _vm.$userIsClient ||
            ((_vm.$userIsTalent || _vm.$userIsManager) &&
              _vm.$showClientDetailsBookingModuleEnabled)
              ? _c("booking-client-details", {
                  attrs: { booking: _vm.booking },
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.canViewRegionalAdminOptions && _vm.$billboardModuleEnabled
              ? _c("booking-tag-targeting", { attrs: { booking: _vm.booking } })
              : _vm._e(),
            _vm._v(" "),
            _vm.$userIsAdmin
              ? _c("booking-notes", { attrs: { booking: _vm.booking } })
              : _vm._e(),
            _vm._v(" "),
            !_vm.$vlastMode
              ? _c(
                  "div",
                  [
                    _vm.canViewRegionalAdminOptions
                      ? _c("booking-source", {
                          attrs: { booking: _vm.booking },
                        })
                      : _vm._e(),
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.$userIsAdmin && !_vm.$vlastMode
              ? _c("booking-sales-pipeline", {
                  key: "1",
                  attrs: { booking: _vm.booking },
                })
              : _vm._e(),
            _vm._v(" "),
            (!_vm.$vlastMode ||
              (_vm.monetaryCurrency && _vm.booking.budget_per_star > 0)) &&
            _vm.canViewRegionalAdminOptions
              ? _c("request-admin-options", {
                  attrs: {
                    booking: _vm.booking,
                    "property-mutator": _vm.setVettingRequestProperty,
                  },
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.$userIsAdmin
              ? _c("booking-history", { attrs: { booking: _vm.booking } })
              : _vm._e(),
            _vm._v(" "),
            _vm.$userIsClient
              ? _c("booking-search-details-list", {
                  attrs: { booking: _vm.booking },
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.$userIsAdmin
              ? _c("booking-download-pdf", { attrs: { booking: _vm.booking } })
              : _vm._e(),
            _vm._v(" "),
            _vm.$userIsAdmin && _vm.booking.can_upload_files
              ? _c("booking-upload-files", { attrs: { booking: _vm.booking } })
              : _vm._e(),
            _vm._v(" "),
            _vm.canViewRegionalAdminOptions
              ? _c(
                  "div",
                  { staticClass: "dashboard-block dashboard-block__actions" },
                  [
                    _c("h2", [_vm._v("Actions")]),
                    _vm._v(" "),
                    _vm.isArchiveDraftRequest
                      ? _c(
                          "div",
                          [
                            _c(
                              "ladda-button",
                              {
                                staticClass: "btn btn-success",
                                attrs: {
                                  click: _vm.handleRestoreDraftRequestCallback,
                                },
                              },
                              [
                                _c("i", { staticClass: "fa fa-check" }),
                                _vm._v(" Restore Draft\n        "),
                              ]
                            ),
                          ],
                          1
                        )
                      : _vm.isDraftVettingRequest
                      ? _c(
                          "div",
                          [
                            _c(
                              "ladda-button",
                              {
                                staticClass: "btn btn-success",
                                attrs: {
                                  click: _vm.handleApproveDraftRequestCallback,
                                },
                              },
                              [
                                _c("i", { staticClass: "fa fa-check" }),
                                _vm._v(" Approve Draft\n        "),
                              ]
                            ),
                            _vm._v(" "),
                            !_vm.$vlastMode
                              ? _c(
                                  "ladda-button",
                                  {
                                    staticClass: "btn btn-delete",
                                    attrs: {
                                      click:
                                        _vm.handleArchiveDraftRequestCallback,
                                    },
                                  },
                                  [
                                    _c("i", { staticClass: "fa fa-check" }),
                                    _vm._v(" Archive Draft\n        "),
                                  ]
                                )
                              : _vm._e(),
                          ],
                          1
                        )
                      : _c(
                          "div",
                          [
                            _c(
                              "ladda-button",
                              {
                                staticClass: "btn btn-success",
                                attrs: {
                                  click: _vm.handleApproveRequestCallback,
                                },
                              },
                              [
                                _c("i", { staticClass: "fa fa-check" }),
                                _vm._v(
                                  " Approve " +
                                    _vm._s(_vm.$t("Request")) +
                                    "\n        "
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                    _vm._v(" "),
                    !_vm.isDraftVettingRequest
                      ? _c(
                          "ladda-button",
                          {
                            staticClass: "btn btn-danger pull-right",
                            attrs: { click: _vm.handleDeclineRequestCallback },
                          },
                          [
                            _c("i", { staticClass: "fa fa-close" }),
                            _vm._v(
                              " Cancel " +
                                _vm._s(_vm.$t("Request")) +
                                "\n      "
                            ),
                          ]
                        )
                      : _vm._e(),
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.canViewRegionalAdminOptions
              ? _c(
                  "div",
                  { staticClass: "dashboard-block dashboard-block__actions" },
                  [
                    _c(
                      "router-link",
                      {
                        staticClass: "btn btn-info",
                        attrs: {
                          to: { name: "vetting.edit", params: { id: _vm.id } },
                        },
                      },
                      [
                        _c("i", { staticClass: "fa fa-pencil" }),
                        _vm._v(
                          " Edit " + _vm._s(_vm.$t("Request")) + "\n      "
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    !_vm.isDraftVettingRequest
                      ? _c(
                          "router-link",
                          {
                            staticClass: "btn btn-info",
                            attrs: {
                              to: {
                                name: "vetting.duplicate",
                                params: { id: _vm.id },
                              },
                            },
                          },
                          [
                            _c("i", { staticClass: "fa fa-clone" }),
                            _vm._v(
                              "   Duplicate " +
                                _vm._s(_vm.$t("Request")) +
                                "\n      "
                            ),
                          ]
                        )
                      : _vm._e(),
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _c("vetting-decline-reason-modal", {
              ref: "modal",
              on: { input: _vm.handleDeclineRequestReason },
            }),
            _vm._v(" "),
            _vm.$userIsAdmin || _vm.$userIsClient
              ? _c("booking-terms-and-conditions-modal-no-action", {
                  attrs: { booking: _vm.booking },
                })
              : _vm._e(),
          ],
          1
        ),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }